import React from 'react';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';

import { IGreenhouseFormValues } from './types';
import { zodResolver } from '@hookform/resolvers/zod';
import { EsgGreenhouseSchema } from './validators';

type GreenhouseFormContext = UseFormReturn<IGreenhouseFormValues>;

type GreenhouseFormSubmission = (
  formUtils: GreenhouseFormContext
) => SubmitHandler<IGreenhouseFormValues>;

type GreenhouseFormProviderProps = {
  children: React.ReactNode;
  onSubmit?: GreenhouseFormSubmission;
  initialValues?: IGreenhouseFormValues;
};

const useGreenhouseForm = useFormContext<IGreenhouseFormValues>;

const defaultFormValues: IGreenhouseFormValues = {
  isAllCompletedTh: false,
  isAllCompletedEn: false,
} as IGreenhouseFormValues;

const GreenhouseFormProvider = (props: GreenhouseFormProviderProps) => {
  const { children, onSubmit, initialValues } = props;

  const formContext = useForm<IGreenhouseFormValues>({
    mode: 'onChange',
    defaultValues: initialValues ?? defaultFormValues,
    resolver: zodResolver(EsgGreenhouseSchema),
  });

  const handleSubmit = onSubmit
    ? formContext.handleSubmit(onSubmit(formContext))
    : (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      };

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }} noValidate>
        {children}
      </form>
    </FormProvider>
  );
};

export { useGreenhouseForm };
export default GreenhouseFormProvider;
